import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "T.DOC:", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Valor:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_select_option = _resolveComponent("a-select-option")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.varios)
      ? (_openBlock(), _createBlock(_component_a_select, {
          key: 0,
          ref: "refSelecionarNumeroTituloFinanceiro",
          class: "ss-tamanho-completo",
          value: _ctx.computedCodigosSelecionados,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigosSelecionados) = $event)),
          "show-search": "",
          mode: "multiple",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          options: _ctx.state.listaTituloFinanceiros,
          disabled: _ctx.props.disabled,
          onChange: _ctx.change,
          onSearch: _cache[1] || (_cache[1] = ($event: any) => (_ctx.pesquisarTituloFinanceiro($event))),
          onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.emDigitacao = false))
        }, _createSlots({ _: 2 }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Títulos"),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["value", "allowClear", "placeholder", "not-found-content", "options", "disabled", "onChange"]))
      : (_openBlock(), _createBlock(_component_a_select, {
          ref: "refSelecionarNumeroTituloFinanceiro",
          class: "ss-tamanho-completo",
          value: _ctx.computedCodigoSelecionado,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
          "show-search": "",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          disabled: _ctx.props.disabled,
          key: _ctx.state.keySelect,
          onChange: _ctx.change,
          onSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.pesquisarTituloFinanceiro($event))),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.emDigitacao = false))
        }, _createSlots({
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaTitulosLocalizados, (titulo) => {
              return (_openBlock(), _createBlock(_component_a_select_option, {
                key: titulo.codigo,
                value: titulo.codigo
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(titulo.numeroTitulo) + " ", 1),
                  _hoisted_1,
                  _createTextVNode(" " + _toDisplayString(titulo.siglaTipoDocumentoFinanceiro) + " ", 1),
                  _hoisted_2,
                  _createTextVNode(" " + _toDisplayString(titulo.nomePessoa) + " ", 1),
                  _hoisted_3,
                  _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(titulo.dataVencimento)) + " ", 1),
                  _hoisted_4,
                  _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(titulo.saldo, 2)), 1)
                ]),
                _: 2
              }, 1032, ["value"]))
            }), 128))
          ]),
          _: 2
        }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Títulos"),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["value", "allowClear", "placeholder", "not-found-content", "disabled", "onChange"]))
  ]))
}